import type { FC } from 'react';

import Stepper from 'components/Stepper';
import { StepOptions } from 'components/Stepper/types';
import TrackView from 'features/Analytics/TrackView';

import RecipientInformation from './steps/RecipientInformation';
import TransferInformation from './steps/TransferInformation';
import TransferSuccess from './steps/TransferSuccess';

const BankTransferRequestNewStepper: FC = () => {
  const steps: StepOptions[] = [
    {
      key: 'recipient-information',
      render: (props) => (
        <>
          <TrackView pageName="BankTransferRequestNewRecipientInformation" />
          <RecipientInformation {...props} />
        </>
      ),
    },
    {
      key: 'transfer-information',
      render: (props) => (
        <>
          <TrackView pageName="BankTransferRequestNewTransferInformation" />
          <TransferInformation {...props} />
        </>
      ),
    },
    {
      key: 'transfer-success',
      render: (props) => (
        <>
          <TrackView pageName="BankTransferRequestNewTransferSuccess" />
          <TransferSuccess {...props} />
        </>
      ),
    },
  ];

  return <Stepper steps={steps} />;
};

export default BankTransferRequestNewStepper;
